import api from '../utils/api';

const parentServicesService = {
  // Absence requests
  listAbsenceRequests: (params = {}) => api.get('/api/absence-requests', { params }),
  createAbsenceRequest: (data) => api.post('/api/absence-requests', data),
  cancelAbsenceRequest: (id) => api.post(`/api/absence-requests/${id}/cancel`),
  reviewAbsenceRequest: (id, data) => api.post(`/api/absence-requests/${id}/review`, data),

  // Document requests
  listDocumentRequests: (params = {}) => api.get('/api/document-requests', { params }),
  createDocumentRequest: (data) => api.post('/api/document-requests', data),
  cancelDocumentRequest: (id) => api.post(`/api/document-requests/${id}/cancel`),
  reviewDocumentRequest: (id, data) => api.post(`/api/document-requests/${id}/review`, data),
  fulfillDocumentRequest: (id, data) => api.post(`/api/document-requests/${id}/fulfill`, data),
  generateTranscript: (id) => api.post(`/api/document-requests/${id}/generate-transcript`),
  // Returns the raw fetch Response — caller does response.blob() and triggers the download.
  downloadTranscript: (id) => api.get(`/api/document-requests/${id}/transcript.pdf`, { raw: true }),

  // Consent forms / permission slips
  listConsentForms: () => api.get('/api/consent-forms'),
  createConsentForm: (data) => api.post('/api/consent-forms', data),
  listConsentFormResponses: (formId) => api.get(`/api/consent-forms/${formId}/responses`),
  listMyConsentResponses: (params = {}) => api.get('/api/consent-forms/my-responses', { params }),
  submitConsentResponse: (responseId, data) => api.post(`/api/consent-forms/responses/${responseId}`, data),

  // Complaints
  listComplaints: (params = {}) => api.get('/api/complaints', { params }),
  createComplaint: (data) => api.post('/api/complaints', data),
  getComplaint: (id) => api.get(`/api/complaints/${id}`),
  addComplaintComment: (id, data) => api.post(`/api/complaints/${id}/comments`, data),
  updateComplaint: (id, data) => api.patch(`/api/complaints/${id}`, data),

  // Acknowledgements
  requestAcknowledgements: (data) => api.post('/api/acknowledgements/request', data),
  getSubjectAcknowledgements: (subjectType, subjectId) => api.get(`/api/acknowledgements/subject/${subjectType}/${subjectId}`),
  listMyAcknowledgements: (params = {}) => api.get('/api/acknowledgements/mine', { params }),
  acknowledge: (id) => api.post(`/api/acknowledgements/${id}/acknowledge`),

  // Kiosk login PIN (shared-device student portal access)
  setKioskPin: (studentId, pin) => api.put(`/api/kiosk/students/${studentId}/pin`, { pin }),

  // Fee reminders (admin)
  getFeeReminderSettings: () => api.get('/api/fee-reminders/settings'),
  updateFeeReminderSettings: (data) => api.put('/api/fee-reminders/settings', data),
  runFeeRemindersNow: () => api.post('/api/fee-reminders/run-now'),
  getFeeReminderHistory: (params = {}) => api.get('/api/fee-reminders/history', { params }),
};

export default parentServicesService;
